/* eslint-disable max-len */
<template>
  <div>
    <div class="account">
      <div>
        <h3 class="account__title">Account List</h3>
      </div>

      <div class="account__content">
        <div class="item" v-for="(item, index) in account_list" :key="index">
          <div class="item__mark">
            <div class="item__mark--chart">{{ item.role | mark_filter }}</div>
          </div>
          <div class="item__title">
            <label class="item__title--main">{{ item.email }}</label>
            <h6>Scope:</h6>
            <li v-for="(scope, index) in item.scope" :key="index">
              {{ scope }}
            </li>
          </div>
          <div>
            <b-button
              class="btn btn-info item__label--btn"
              v-b-modal.scopeModal
              @click="sendScopeToModal(item)"
              >Scope</b-button
            >
            <b-button
              class="btn btn-info item__label--btn"
              v-b-modal.roleModal
              @click="sendRoleToModal(item)"
              >Role</b-button
            >
            <b-button
              class="btn btn-danger item__label--btn"
              @click="confirmDelete(item)"
              >Delete</b-button
            >
          </div>
        </div>
      </div>
      <!-- role -->
      <b-modal id="roleModal" title="Change Account Role" @ok="changeRole()">
        <b-form-group label="Roles:">
          <b-form-radio v-model="role_selected" name="some-radios" value="admin"
            >Admin</b-form-radio
          >
          <b-form-radio
            v-model="role_selected"
            name="some-radios"
            value="labeller"
            >Labeller</b-form-radio
          >
        </b-form-group>
      </b-modal>

      <!-- scope -->
      <b-modal id="scopeModal" title="Change Account Scope" @ok="changeScope()">
        <b-form-group label="Scopes:">
          <b-form-checkbox-group
            id="checkbox-group-1"
            v-model="curr_scopes"
            :options="options"
            name="scopes"
          ></b-form-checkbox-group>
        </b-form-group>
      </b-modal>
    </div>
  </div>
</template>
<script>
import client from "@/api/client";

export default {
  data() {
    return {
      account_list: [],
      type: "",
      curr_account: "",
      role_selected: "",
      curr_scopes: [],
      options: [
        { text: "sleep_main ", value: "sleep_main" },
        { text: "sleep_occl", value: "sleep_occl" },
        { text: "sleep_detection", value: "sleep_detection" },
        { text: "audio_v2", value: "audio_v2" },
        { text: "live", value: "live_main" },
        { text: "emotion", value: "emotion" },
        { text: "caregiver", value: "caregiver" }
      ]
    };
  },
  methods: {
    loadAccountList() {
      const vm = this;
      client
        .get("/account/list")
        .then(res => {
          vm.account_list = res.results;
        })
        .catch(err => {
          if (err === 401) {
            vm.$router.push("/login");
          }
        });
    },
    sendScopeToModal(item) {
      const vm = this;
      vm.curr_account = item;
      vm.curr_scopes = item.scope;
    },
    sendRoleToModal(item) {
      const vm = this;
      vm.curr_account = item;
      vm.role_selected = item.role;
    },
    changeRole() {
      const vm = this;
      console.log(
        `Change role: ${vm.curr_account.email} -> ${vm.role_selected}`
      );
      client
        .put("/account/role", null, {
          email: vm.curr_account.email,
          role: vm.role_selected
        })
        .then(res => {
          vm.loadAccountList();
        });
    },
    changeScope() {
      const vm = this;
      console.log(
        `Change scope: ${vm.curr_account.email} -> ${vm.curr_scopes}`
      );

      client
        .put("/account/scope", null, {
          email: vm.curr_account.email,
          scopes: vm.curr_scopes
        })
        .then(res => {
          vm.loadAccountList();
        });
    },
    confirmDelete(item) {
      const vm = this;
      this.boxOne = "";
      this.$bvModal
        .msgBoxConfirm(`Delete account ${item.email} ?`)
        .then(value => {
          console.log(`do delete: ${item.email}`);
          client.delete("/account", null, { email: item.email }).then(res => {
            vm.loadAccountList();
          });
        });
    }
  },
  filters: {
    mark_filter(data) {
      return data.substr(0, 1);
    }
  },
  mounted() {
    if (localStorage.token.length > 0) {
      this.loadAccountList();
    } else {
      this.$router.push("/login");
    }
  }
};
</script>
